module.exports = __webpack_public_path__ + "img/logo-mutuali-cibim.7e9f8547.svg";